import script from "./CertificateTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateTab.vue?vue&type=script&setup=true&lang=js"

import "./CertificateTab.vue?vue&type=style&index=0&id=0e84c45a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e84c45a"]])

export default __exports__